module.exports = __webpack_public_path__ + "static/dg-2-6709f1284e3ff5417c7c5624615c2445.png";